/**
 * Period-relative comparison label, e.g. "vs la semaine précédente".
 * Single source of truth so every KPI tile shows the precise wording for the
 * selected period type (week/month/quarter/year).
 */
export const getPeriodComparisonLabel = (periodType) => {
  switch (periodType) {
    case 'week':
      return 'vs la semaine précédente';
    case 'month':
      return 'vs le mois précédent';
    case 'quarter':
      return 'vs le trimestre précédent';
    case 'year':
      return "vs l'année précédente";
    default:
      return 'vs la période précédente';
  }
};
